import isEmail from 'validator/lib/isEmail'
import axios, { AxiosResponse } from 'axios'
import { useState } from 'react'
import { TFunction } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import useLoadingStore from '../../stores/useLoadingStore'
import ConfigAPI from '../../constant/ConfigAPI'

export type Response = { result?: AxiosResponse<any>; error?: any }

export interface Form {
    email?: string
}

export const validate = async (values: Form, t: TFunction<'translation'>) => {
    const errors: Partial<Form> = {}
    if (!values.email) {
        errors.email = `${t('LABEL.TEXT_REQUIRED')}`
    }
    if (values.email && !isEmail(values.email)) {
        errors.email = `${t('VALIDATE.MESSAGES.EMAIL')}`
    }
    return errors
}

const useForgetISYL = () => {
    const [openDialogOk, setOpenDialogOk] = useState<boolean>(false)
    const [alertMessageOk, setAlertMessageOk] = useState<string>('')
    const [openDialogError, setOpenDialogError] = useState<boolean>(false)
    const [alertMessageError, setAlertMessageError] = useState<string>('')
    const [statusCode, setStatusCode] = useState<number>()
    const loadingStore = useLoadingStore()
    const history = useHistory()

    const callService = async (data: Form) => {
        try {
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/auth/forgetPassword`
            const reqParams = {
                email: data.email,
            }
            const result = await axios.post(url, reqParams, ConfigAPI)
            if (result.status === 200) {
                setStatusCode(200)
                setAlertMessageOk('กรุณาตรวจสอบการตั้งค่ารหัสผ่านในอีเมล')
                setOpenDialogOk(true)
            }
            return { result }
        } catch (error) {
            //@ts-ignore
            const errMsg: string = error?.toString()
            if (errMsg) {
                if (errMsg.includes('404')) {
                    setStatusCode(404)
                    setOpenDialogOk(true)
                    setAlertMessageOk('ไม่พบอีเมลนี้ในระบบ')
                } else {
                    setStatusCode(500)
                    setOpenDialogError(true)
                    setAlertMessageError('ไม่สามารถตั้งค่ารหัสผ่านใหม่ได้')
                }
            }
            return { error }
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const handleSubmitForm = (values: any) => {
        callService(values as Form)
    }

    const handleClickOk = () => {
        setOpenDialogOk(false)
        setOpenDialogError(false)
        if (statusCode !== 404) {
            if (statusCode === 200) {
                history.push('/login')
            } else {
                history.push('/')
            }
        }
    }

    return {
        onSubmitForm: handleSubmitForm,
        onClickOk: handleClickOk,
        openDialogOk,
        alertMessageOk,
        openDialogError,
        alertMessageError,
    }
}

export default useForgetISYL
